import React, { useCallback, useEffect, useRef, useState } from 'react';
import LoaderFull from '../shared/loader-full-screen';
import { useClientListPagewise } from './hooks';
import { Outlet, useOutletContext, useSearchParams } from 'react-router-dom';
//import { PopupAddClient } from './popupAddClient';
//import { useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { RECORDS_PER_PAGE } from '../../config';
import { useDebouncedState } from '@mantine/hooks';
import { PAGE_SIZE_OPTIONS, handleSearchKeys, handleSortUtil } from '../utils';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
const SORT_KEY_CONST = 'client_list_sort_key'
const SORT_ORDER_CONST = 'client_list_sort_order'
const PAGE_NO_CONST = 'client_list_page_no'

function ListClientsIndex() {
	const {getpageSizeCall, setpageSizeCall} = useOutletContext();
	const [DebounceSearch, setDebounceSearch] = useDebouncedState('', 500);
	//const PrivilagesList = useSelector((state) => state?.privilageSlice?.allowedActions)
	const [searchParams, setSearchParams] = useSearchParams();
	const isFirstRender = useRef(true)


	const [Sort, setSort] = useState(handleSearchKeys(searchParams,SORT_KEY_CONST,SORT_ORDER_CONST,PAGE_NO_CONST));	
	const {hook: client_list_hook ,Args,setArgs } = useClientListPagewise(Sort.page,  Sort.sort)

	//const [IsOpened, setIsOpened] = useState(false);

	function handleSort(typer) {
		let {sort_key ,sort_order} = handleSortUtil(typer , Sort)
		searchParams.set(SORT_KEY_CONST, sort_key)
		searchParams.set(SORT_ORDER_CONST, sort_order)
		setSearchParams(searchParams)

	}	

	useEffect(() => {		
		if (!isFirstRender.current) {
			let newSort = handleSearchKeys(searchParams, SORT_KEY_CONST, SORT_ORDER_CONST, PAGE_NO_CONST)			
			setSort(newSort)
			setArgs((p) => {
				return {
					...p,
					...newSort
				}
			})
		}
		isFirstRender.current = false


	}, [searchParams, setArgs])
	


	const renderList = useCallback(() => {
		if (client_list_hook.isFetching) {
			return <LoaderFull />;
		} else if (client_list_hook.data?.data?.length === 0) {
			return <p className="text-center">No data found</p>;
		} else {
			return (
				<Outlet
					context={{
						clientList: client_list_hook.data,
						Search: DebounceSearch,
					}}
				/>
			);
		}
	}, [client_list_hook.isFetching , client_list_hook.data, DebounceSearch ]);

	const [pageSize, setPageSize] = useState(null);

	useEffect(() => {
		// Define an async function inside useEffect
		const fetchPageSize = async () => {
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, "pg in client");
			setPageSize(page_size);  // Set the page size state
		} catch (error) {
			console.error("Error fetching page size:", error);
		}
		};

		fetchPageSize();  // Call the async function

	}, []);  //
	
	const handlePageSizeChange = async (event) => {
		const selectedPageSize = event.target.value;
		setPageSize(null)
		let ret = await setpageSizeCall(selectedPageSize)
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, "pg in client");
			setPageSize(page_size);  // Set the page size state
		} catch (error) {
			console.error("Error fetching page size:", error);
		}

	};

	useEffect(() => {

	  if (pageSize) { 
		searchParams.set(PAGE_NO_CONST, 1)
		setSearchParams(searchParams)
		setArgs(p=> {
			return { 
				...p,
				page: 1
			}
		})
		if (searchParams.get(PAGE_NO_CONST) ==1){
			client_list_hook.refetch()
		}
	  }
	}, [pageSize])
	
	

	return (
		<>
			<div className="grow h-screen overflow-x-hidden overflow-y-auto fontInter">
				<>
					<div className="lg:flex gap-4 justify-between items-center vLBG py-4 px-6">
						<div>
							<h1 className="text-lg font-normal text-primary">
								List of <strong className="font-black">Clients</strong>
							</h1>
							<p className="text-xs text-gray-500 mb-2">
								List of all your clients is given below -
							</p>
						</div>
						<div className="flex gap-3 flex-wrap">
							<div className="flex gap-2">
								<div className="relative">
									<span className="material-icons absolute top-2 left-2 z-10 text-slate-400 text-md">
										search
									</span>
									<input
										type="text"
										onChange={(e) => {
											setDebounceSearch(()=> {
												setArgs((p) => {
													return { ...p, search: e.target.value, page: 1, sort: '' };
												});
												return e.target.value
											});
										}}
										className="border relative border-slate-300 rounded-md w-full h-10 py-2 pr-2 pl-10 focus:outline-blue-400 text-sm"
										placeholder="Search..."
										defaultValue={Args.search}
									/>
								</div>
							</div>
							{/* <div>
								{PrivilagesList.includes('add_client') && (
									<button
										onClick={() => setIsOpened(true)}
										className="bg-blue-800 hover:bg-indigo-700 flex items-center px-4 h-[40px] text-sm font-black rounded-md text-white"
									>
										<span className="material-icons text-white text-sm mr-1">
											add
										</span>
										Add New Client
									</button>
								)}
							</div> */}
						</div>
					</div>
					<div className="p-6">
						<div className="listDHeight overflow-auto">
							<div className="flex gap-2 mb-2">
								<div className="flex-none text-center relative w-[55px]">
								<span title='default sort' onClick={() => handleSort('')} className={`${Sort.type === '' ? 'text-primary' : 'cursor-pointer'}   material-icons w-4 text-sm mt-1`}>										swap_vert
									</span>
								</div>
								<div className="grow px-5 py-1 text-xs flex items-center justify-between">
									<div className="grow pr-4">
										<label
											onClick={() => handleSort('name')}
											className={`${Sort.type === 'name' ? 'text-primary' : ''} font-black block w-[110px] relative cursor-pointer`}
										>
											Name of Client
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[-2px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<label
											onClick={() => handleSort('total_vendors')}
											className={`${Sort.type === 'total_vendors' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											Total Vendors
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[-2px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<label
											onClick={() => handleSort('total_invoices')}
											className={`${Sort.type === 'total_invoices' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											Total Invoices
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[-2px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[155px]">
										<label
											onClick={() => handleSort('total_contracts')}
											className={`${Sort.type === 'total_contracts' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											Total Contracts
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[-2px]">
												swap_vert
											</span>
										</label>
									</div>
								</div>
								<div className="flex-none w-[141px] pr-2">&nbsp;</div>
							</div>
							{renderList()}
							
						</div>

						<div className="flex justify-center pt-2">
							
							{!client_list_hook.isLoading && (
								<>
								<div className="flex items-center justify-between space-x-4">
									{/* Pagination Component */}
									<div className="flex items-center space-x-2">
										{/* <p>Rows per page</p>   */}
									{pageSize ? (
										<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
										// <select
										// value={pageSize || ''}
										// onChange={handlePageSizeChange}
										// className="p-2 rounded-md border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
										// >
										// <option value={10}>10</option>
										// <option value={20}>20</option>
										// <option value={40}>40</option>
										// <option value={50}>50</option>
										// <option value={100}>100</option>
										// <option value={200}>200</option>
										// </select>
									) : (
										<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">autorenew</span> {/* Spinner */}
										</div>
									)}
									</div>

									<Pagination
									page={Sort.page}
									onChange={(e, value) => {
										searchParams.set(PAGE_NO_CONST, value);
										setSearchParams(searchParams);
									}}
									count={Math.ceil(client_list_hook.data?.total_clients / pageSize)}
									color="primary"
									variant="outlined"
									shape="rounded"
									className="w-full sm:w-auto"
									/>

									{/* Page Size Dropdown or Spinner */}
									
									
								</div>
								</>


							)}
							
						</div>
					</div>
				</>
				{/* {IsOpened && (
					<PopupAddClient
						isOpened={IsOpened}
						setIsOpened={setIsOpened}
					/>
				)} */}
			</div>
		</>
	);
}

export default ListClientsIndex;
